import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { ObserveVisibility } from 'vue-observe-visibility'
import VueAnalytics from 'vue-analytics'
import VueYoutube from 'vue-youtube'

if (
  !('IntersectionObserver' in window) &&
  !('IntersectionObserverEntry' in window) &&
  !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
) {
  import(
    /* webpackChunkName: "intersection-observer-polyfill" */ 'intersection-observer'
  )
}

Vue.directive('observe-visibility', ObserveVisibility)

Vue.use(VueAnalytics, {
  id: 'UA-141401913-1',
  router
})

Vue.use(VueYoutube)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
